import React from 'react';
import { PageHero, Section } from '@/components/shared/Section';
import { Scale } from 'lucide-react';

export default function CorporateInfoPage() {
  return (
    <div>
      <PageHero
        badge="INFORMACIÓN CORPORATIVA"
        badgeIcon={Scale}
        h1="Gobierno corporativo y compliance"
        subtitle="Información corporativa, estructura organizacional y cumplimiento normativo de ALLCOM S.A."
      />
      
      <Section>
        <div className="max-w-3xl mx-auto text-center">
          <div className="p-12 rounded-2xl bg-slate-50 border border-slate-200">
            <p className="text-slate-500">
              Contenido en preparación. Próximamente publicaremos información detallada sobre nuestra estructura corporativa.
            </p>
          </div>
        </div>
      </Section>
    </div>
  );
}
